const interpolate = (template, context) => template.replace(/\{\{(\w+)\}\}/g, (_, key) => {
    const value = context[key];
    if (value === undefined)
        return '';
    return typeof value === 'string' ? value : JSON.stringify(value);
});
/**
 * Resolves the display message for a finding from pre-fetched locale translations.
 *
 * Accepts translations as a parameter so callers control when and how the locale
 * is fetched (e.g. hoisted to a page-level component alongside other data fetches).
 *
 * Returns `undefined` if translations are not yet available or if no matching
 * template is found, allowing callers to fall back (e.g. to fileName or id).
 *
 * Usage:
 *   - Backoffice: fetch with useGetLocaleQuery('en'), pass data here
 *   - Frontend: fetch with useGetLocaleQuery(useCurrentLanguage()), pass data here
 */
export const resolveFinding = (finding, translations) => {
    if (!translations || !finding.messageTemplate) {
        return undefined;
    }
    const contextEn = finding.messageContextEn ?? {};
    const context = Object.keys(contextEn).length > 0 ? contextEn : (finding.messageContext ?? {});
    const template = translations[finding.messageTemplate];
    if (!template) {
        return undefined;
    }
    return interpolate(template, context);
};
